import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M7.667 13.667A3.673 3.673 0 004 17.334v2.333a.333.333 0 00.333.333H5.54a.167.167 0 01.167.154L6 23.694a.333.333 0 00.333.306H9a.333.333 0 00.333-.306l.294-3.54A.167.167 0 019.793 20H11a.333.333 0 00.333-.333v-2.333a3.673 3.673 0 00-3.666-3.667zM7.667 12.667a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
